import { ConfirmDialog } from "../../../../components/ui";

/**
 * PeriodActionDialog — confirms a payroll step that is a handoff or cannot be
 * quietly undone (send to Finance, release, reopen, revert, cancel). It is the
 * shared ConfirmDialog with payroll's wording; the server decides whether the
 * step is allowed, and a refusal stays in the dialog in its own plain words.
 */
export default function PeriodActionDialog({ title, description, confirmLabel, danger = false, failureTitle, onConfirm, onClose, children }) {
  return (
    <ConfirmDialog
      size="md"
      title={title}
      description={description}
      confirmLabel={confirmLabel}
      tone={danger ? "danger" : "default"}
      failureTitle={failureTitle}
      errorFallback="This step couldn't be completed. Try again."
      onConfirm={onConfirm}
      onClose={onClose}
    >
      {children}
    </ConfirmDialog>
  );
}
